import * as React from "react";
import { useTranslate } from "ra-core";
import {
  List,
  //SearchInput,
  TopToolbar,
  CreateButton,
  FilterButton,
  SelectColumnsButton,
  CloneButton,
  ExportButton,
  TextField,
  ReferenceField,
  ReferenceInput,
  SelectInput,
  TextInput,
  EmailField,
  DateField,
  EditButton,
  ShowButton,
  usePermissions,
  FunctionField,
} from "react-admin";
import * as buttons from "components/ui/buttons";
import { Box } from "@mui/material";
import { TreeDatagrid } from "components/ui/tree-datagrid";

const getCompanyFilters = (permissions: string): React.ReactElement[] => {
  const filters = [
    <TextInput source="name" key="f_name" />,
    <TextInput source="short_name" key="f_short_name" />,
    <ReferenceInput source="type_id" reference="company-types" key="f_type">
      <SelectInput optionText="name" emptyValue="" />
    </ReferenceInput>,
  ];
  if (permissions === "admin") {
    filters.push(<TextInput source="role" key="f_role" />);
  }
  return filters;
};

const ListActions = () => (
  <TopToolbar>
    <CreateButton />
    <FilterButton />
    <SelectColumnsButton />
    <ExportButton />
  </TopToolbar>
);

// Возвращает массив полей-колонок
const buildColumns = (
  level: number,
  t: (key: string) => string,
): React.ReactElement[] => [
  <FunctionField
    key={`col_name_${level}`}
    label={t("resources.companies.fields.name")}
    render={(rec: any) => <Box sx={{ pl: level * 2 }}>{rec?.name}</Box>}
  />,
  <TextField
    key={`col_short_${level}`}
    source="short_name"
    label={t("resources.companies.fields.short_name")}
  />,
  <ReferenceField
    key={`col_type_${level}`}
    label={t("resources.companies.fields.type_id")}
    source="type_id"
    reference="company-types"
  >
    <TextField source="name" />
  </ReferenceField>,
  <EmailField
    key={`col_email_${level}`}
    source="email"
    label={t("resources.companies.fields.email")}
  />,
  <EmailField
    key={`col_tz_${level}`}
    source="timezone"
    label={t("resources.companies.fields.timezone")}
  />,
  <DateField
    key={`col_created_${level}`}
    showTime
    source="created_at"
    label={t("resources.common.fields.created_at")}
  />,
  <FunctionField
    key={`col_actions_${level}`}
    label={t("internal.actions")}
    render={() => (
      <>
        <ShowButton label="" title={t("ra.action.show")} />
        <EditButton label="" title={t("ra.action.edit")} />
        <CloneButton label="" title={t("ra.action.clone")} />
        <buttons.DeleteWithConfirmButtonX
          title={t("ra.action.remove")}
          field="name"
        />
      </>
    )}
  />,
];

const CompanyList = () => {
  const { permissions } = usePermissions();
  const t = useTranslate();

  return (
    <List
      filters={getCompanyFilters(permissions)}
      // Отображаем только корневые записи
      filter={{ parent_id: null }}
      sort={{ field: "created_at", order: "DESC" }}
      actions={<ListActions />}
    >
      <TreeDatagrid
        reference="companies"
        target="parent_id"
        showChildrenThead={false}
        parentId={null}
        buildColumns={(level) => buildColumns(level, t)}
      />
    </List>
  );
};

export default CompanyList;
